export default "__VITE_ASSET__DqrTd0rO__"